import { UserManager, User } from "oidc-client";
import calculateMunicipalityKey from "../../Hooks/Municipality";
import { loginFailed, loginStarted, loginSuccess, logoutFailed, logoutSuccess } from "./authSlice";

const currentMunicipality = calculateMunicipalityKey();


export const manager = new UserManager({
  authority: import.meta.env.VITE_OIDC_AUTHORITY,
  client_id: import.meta.env.VITE_OIDC_CLIENT,
  redirect_uri: window.location.origin + "/login/response",
  post_logout_redirect_uri: window.location.origin + "/logout/response",
  response_type: "code",
  scope: "openid profile krr:user/kontaktinformasjon.read ks:fiks",
  acr_values: "idporten-loa-substantial",
  ui_locales: "nb",
  loadUserInfo: false,
  revokeAccessTokenOnSignout: false,
  extraQueryParams: {
    resource: import.meta.env.VITE_OIDC_RESOURCE,
    onbehalfof: currentMunicipality.number,
  },
});

export const login = () => (dispatch: Function) => {
  dispatch(loginStarted());
  manager.getUser().then((user: User | null) => {
    if (!!user && !user.expired) {
      dispatch(loginSuccess(user));
    } else {
      manager
        .signinRedirect({state: {location: sessionStorage.getItem('location')}})
        .catch((error: Error) => dispatch(loginFailed(error)));
    }
  });
  // Setup autorefresh
  manager.events.addAccessTokenExpiring(() => {
    manager.signinSilent().then(() => {
      manager.getUser().then((user: User | null) => {
        if (!!user && !user.expired) {
          dispatch(loginSuccess(user));
        }
      });
    });
  });
};

export const completeLogin = () => async (dispatch: Function) => {
  await manager
    .signinRedirectCallback()
    .then(() => {
      manager.getUser().then((value: User | null) => {
        if (value === null) throw new Error("Failed to get user");
        dispatch(loginSuccess(value));
        window.location.href = sessionStorage.getItem('location') || window.location.href;
      });
    })
    .catch((error: Error) => {
      dispatch(loginFailed(error));
    });
};

export const logout = () => (dispatch: Function) => {
  manager
    .signoutRedirect()
    .catch((error: Error) => dispatch(logoutFailed(error)));
};

export const completeLogout = () => (dispatch: Function) => {
  manager
    .signoutRedirectCallback()
    .then(manager.removeUser)
    .then(() => {
      return dispatch(logoutSuccess());
    })
    .catch((error) => dispatch(logoutFailed(error)));
};
